<script>
  import Button from '@components/buttons/button.svelte'
  import { CalendarPlus } from 'lucide-svelte'
  import { cn } from '@lib/utils'

  let { label = "Download (.ics)", title, startTime, endTime, description = '', location = '', class: className, ...buttonProps } = $props()

  function toICSDate(date) {
    return new Date(date).toISOString().replace(/[-:]/g, '').replace(/\.\d{3}/, '')
  }

  let href = $derived.by(() => {
    const lines = [
      'BEGIN:VCALENDAR',
      'VERSION:2.0',
      'PRODID:-//Altruist Wellbeing//EN',
      'BEGIN:VEVENT',
      `DTSTART:${toICSDate(startTime)}`,
      `DTEND:${toICSDate(endTime)}`,
      `SUMMARY:${title}`,
      description ? `DESCRIPTION:${description.replace(/\n/g, '\\n')}` : null,
      location ? `LOCATION:${location}` : null,
      'END:VEVENT',
      'END:VCALENDAR',
    ].filter(Boolean).join('\r\n')

    return `data:text/calendar;charset=utf-8,${encodeURIComponent(lines)}`
  })
</script>

<Button variant="link" text={label} Icon={CalendarPlus} externalPath={href} download="{title}.ics" target="_self" 
  class={className} {...buttonProps} />
